module.exports = __webpack_public_path__ + "static/media/cardio.6b5158cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardio.png
// module id = 747
// module chunks = 0